module.exports = __webpack_public_path__ + "static/media/Tick.8645f991.svg";